import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import Mousetrap from 'mousetrap'
import Styled from 'styled-components'
import Uuid from 'uuid'

const Container = Styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

class Modal extends Component {
  static mousetrap = new Mousetrap()
  static callbacks = []

  constructor(props) {
    super(props)

    this.uuid = Uuid()
  }

  componentWillMount() {
    if (Modal.callbacks.length === 0) {
      document.body.classList.add('no-scroll')

      Modal.mousetrap.bind('esc', () => {
        Modal.callbacks[Modal.callbacks.length - 1][1]()
      })
    }

    Modal.callbacks.push([this.uuid, this.handleClose.bind(this)])
  }

  componentWillUnmount() {
    Modal.callbacks = Modal.callbacks.filter(([uuid]) => {
      return uuid !== this.uuid
    })

    if (Modal.callbacks.length === 0) {
      document.body.classList.remove('no-scroll')

      Modal.mousetrap.unbind('esc')
    }
  }

  handleClose = () => {
    this.props.onClose()
    return true
  }

  render() {
    const children = (
      <Container>
        {this.props.children}
      </Container>
    )

    return ReactDOM.createPortal(
      children,
      document.getElementById('modal-root')
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/index.js